<template>
    <Mz-Dialog class="dialog" :title="title" width="5000px" :visible.sync="visible" @handleClose="handleClose">
        <div slot="content" class="main" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(0,0,0,0)">
            
            <div class="chart" id="chart"></div>
            <div class="image">
                <img :src="data.xgcp">
            </div>
        </div>
    </Mz-Dialog>
</template>

<script>
import echarts from 'echarts'
    export default {
        components: {},
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            data: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                loading: false
            }
        },
        created() {
        },
        mounted() {
            this.$nextTick(() => {
                this.echarts()
            })
        },
        methods: {
            echarts(){
                var chart = echarts.init(document.getElementById('chart'));
                let dataX = this.data.data[0].data
                let series = [] 
                let names = []
                this.data.data.forEach(it => {
                    series.push({
                        type: 'bar',
                        barGap: 0,
                        name: it.name,
                        data: it.data,
                        label: {
                        show: true,                    // 显示标签
                        position: 'top',               // 标签显示在柱子顶部
                        fontSize: 43,
                        color: '#fff',                 // 数值颜色
                        fontWeight: 'normal',
                        // 可选：格式化显示内容
                        formatter: '{c}',// {c} 表示数值，{a}系列名，{b}类目名
                    },
                    })
                    names.push(it.name)
                });
                // 清空图表
                chart.clear();
                chart.setOption({
                    // 设置绘图区域的边距
                    grid: {
                        left: 224,   // 左侧距离
                        right: 130,  // 右侧距离
                        top: 300,   // 可选：顶部距离
                        bottom: 0, // 可选：底部距离
                        containLabel: true, // 确保标签不被裁剪
                        borderColor: '#fff',
                    },
                    color: ['#085BA9','#34B3E9'],
                    tooltip: {
                        trigger: 'item',
                        textStyle: {
                            color: '#fff',
                            fontSize: 32, 
                            fontWeight: 'bold', 
                        },
                    },
                    legend: {
                        data: names,
                        left: "center",
                        top: 60,
                        textStyle: {
                            fontSize: 42,
                            color: '#fff',
                            padding:[0,27]
                        },
                        icon: 'rect', 
                        itemWidth: 54,
                        itemHeight: 42,
                        itemGap: 80
                    },
                    xAxis: {
                        type: 'category',
                        data: dataX.map(it => it.name),
                        axisTick: { show: false},
                        axisLine: {show: false},
                        boundaryGap: false, // 去掉左右两边的空白
                        axisLabel: {
                            color: '#fff', // 文字颜色
                            fontSize: 42,   // 字体大小
                            margin: 60,
                            lineHeight: 60,
                            rotate: 45,
                            formatter: function (value, index) {
                                // value 是当前的数据项的 name 属性，index 是当前数据项的索引
                                var item = dataX[index]; // 获取当前数据项
                                return item.name + '\n' + item.unit ;
                            },
                        },
                        
                    },
                    yAxis: {
                        type: 'log',
                        scale: true,           // ✅ 关键：让轴范围紧贴数据
                        min: 'dataMin',        // ✅ 关键：最小值 = 数据中的最小值（如 0.5）
                        max: 'dataMax',        // ✅ 可选：最大值 = 数据中的最大值
                        axisLine: {show: false},
                        splitLine: { show: false },
                        axisTick: { show: false },
                        axisLabel: {show: false},
                    },
                    series: series
                })
            },
            handleClose(){
                this.$emit('update:visible', false)
            }
        }
    }
</script>

<style lang="less" scoped>
@import '@/styles/common';
.main{
    padding: 139px 180px 170px 200px;
}
.image{
    margin-top: 50px;
    text-align: center;
    img{
        width: 100%;
    }
}
.chart{
    width: 100%;
    height: 1500px;
    background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="62" height="62"><rect width="60" height="60" stroke="%231C3763" fill="none" stroke-width="1" x="1" y="1"/></svg>') repeat;
}
</style>